export const registrationConstante = Object.freeze({
  REGISTRATION_ACTOR_APPRENTICE: 1,
  REGISTRATION_ACTOR_COMPANY: 2,
  REGISTRATION_ACTOR_CFA: 3,
  REGISTRATION_ACTOR_UFA: 4,

  REGISTRATION_SALARY_TAB_CODE: "tab-salary",
  REGISTRATION_QUOTE_TAB_CODE: "tab-quote",
  REGISTRATION_DOCUMENT_TAB_CODE: "tab-files",
  REGISTRATION_CONTRACT_TAB_CODE: "tab-contract",

  REGISTRATION_COMPANY_TAB_CODE: "tab-company",
  REGISTRATION_APPRENTICE_TAB_CODE: "tab-apprentice",

  REGISTRATION_CONTRACT_BLOCK_CODE: "contract-contract",
  REGISTRATION_LEGAL_RESPONSIBLE: "apprentice-legal-responsible",
  REGISTRATION_APPRENTICE_PERSONAL_INFORMATION: "apprentice-personal-informations",
  REGISTRATION_CONTRACT_FILING_BLOCK_CODE: "document-contract-filing",

  REGISTRATION_CONTRACT_MODEL: "employmentContract",
  REGISTRATION_APPRENTICE_BIRTHDAY: "apprentice::birthday",
  REGISTRATION_GIVE_MANDATE_MODEL: "giveMandate",
  REGISTRATION_CONTRACT_START_DATE_MODEL: "startDate",

  REGISTRATION_STATUS_UPCOMING: 1,
  REGISTRATION_STATUS_IN_PROGRESS: 2,
  REGISTRATION_STATUS_FINALIZED: 3,
  REGISTRATION_STATUS_RUPTURE: 4,
  REGISTRATION_STATUS_CANCELLED: 5,

  REGISTRATION_STEP_STATUS_NONE: 0,
  REGISTRATION_STEP_STATUS_PENDING: 1,
  REGISTRATION_STEP_STATUS_VALIDATED: 2,
  REGISTRATION_STEP_STATUS_REFUSED: 3,
  REGISTRATION_STEP_STATUS_CANCELLED: 5,

  SMC_DISABLE_PERCENT_MIN_VALUE: 1,

  CONTRACT_APPRENTICESHIP_HORS_APPRENTISSAGE: 0,
  CONTRACT_APPRENTICESHIP_APPRENTISSAGE: 1,
  CONTRACT_PRO_CFA: 2,
  CONTRACT_PROFESSIONAL_TRAINING: 3,

  contractTypeTargetAudiencesLabels: {
    1: "registration.contractType.apprentice",
    2: "registration.contractType.pro",
  },

  REGISTRATION_STATUS: {
    1: "init",
    2: "to_send_to_training_center",
    3: "sent_to_training_center",
    4: "validated_training_center",
    5: "signed",
    6: "error",
    7: "archived",
  },

  CERFA_NOTICE_URL_APPRENTICESHIP:
    "https://www.formulaires.service-public.gouv.fr/gf/getNotice.do?cerfaNotice=51649&cerfaFormulaire=10103",
  CERFA_NOTICE_URL_PRO:
    "https://www.formulaires.service-public.gouv.fr/gf/getNotice.do?cerfaNotice=51650&cerfaFormulaire=12434",
});

export function getDuplicateSheetAction(t) {
  return {
    action: "duplicateSheet",
    actionParams: [{ title: "registration", code: "crypted_id" }],
    icon: "copy",
    tooltip: t("registration.group_action.duplicate.title"),
    type: "button",
    className: "success",
  };
}

export function getDownloadCommitmentsCertificateAction(t) {
  return {
    action: "downloadCommitmentsCertificate",
    actionParams: [{ title: "registration", code: "crypted_id" }],
    icon: "download",
    tooltip: t("registration.group_action.download.commitments"),
    type: "button",
    className: "success",
    requiredFields: ["commitments"],
  };
}
